// WonderTime brand configuration
export const BRAND = {
  name: "Wonder Time",
  team: "Team Curious Roots",
  // WhatsApp number in international format
  whatsappNumber: "+919741175259",
  get whatsappUrl() {
    const digits = this.whatsappNumber.replace(/\D/g, "");
    const msg = encodeURIComponent(
      "Hi Team Curious Roots! I'd like to know more about the Wonder Time cohort.",
    );
    return `https://wa.me/${digits}?text=${msg}`;
  },
};

export const PRICING = {
  mrp: 2999,
  launch: 999,
  currency: "₹",
};

// Razorpay hosted payment page
export const PAYMENT_URL = "https://rzp.io/rzp/qrValJy1";

// Explainer video (YouTube)
export const VIDEO = {
  youtubeId: "JFVvd7WaKU0",
  get poster() {
    return `https://img.youtube.com/vi/${this.youtubeId}/maxresdefault.jpg`;
  },
  get embedUrl() {
    return `https://www.youtube-nocookie.com/embed/${this.youtubeId}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
  },
};
